import React from 'react';
import { Alert, Dialog, DialogTitle, DialogContent, Divider, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import SubscriptionAlert from '../Status/SubscriptionAlerts';

const PreviewDialog = ({ open = false, onClose, data = null, fileName = null }) => {
    const subscription = useSelector((state) => state.auth.subscription);
    const isTrial = subscription?.name?.toLowerCase() === 'trial';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 3,
                    padding: '12px 24px',
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 700,
                    fontSize: '18px',
                    padding: '16px 0',
                    borderBottom: '1px solid #E1E8ED',
                }}
            >
                Preview - {fileName}
                <IconButton onClick={onClose}>
                    <Close fontSize="small" sx={{ color: '#444' }} />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent
                sx={{
                    px: 0,
                    py: 3,
                    userSelect: 'none', // Disables text selection
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                }}
                onCopy={(e) => e.preventDefault()} // Prevents copy command
            >
                {isTrial ? <TrialPlanAlert /> : <SubscribedPlanAlert />}
                <Typography
                    style={{ fontSize: '14px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                    {data}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default PreviewDialog;

const TrialPlanAlert = () => (
    <SubscriptionAlert
        severity="warning"
        prefixMessage="To access the complete extracted content, please"
        actionText="subscribe"
        suffixMessage="to a plan."
    />
);

const SubscribedPlanAlert = () => (
    <Alert severity={'info'} sx={{ mb: 2 }}>
        To view the complete extracted content, please download the course from the Actions menu.
    </Alert>
);
